<template>
  <h1>
    <slot></slot>
  </h1>
</template>

<script>
export default {
  name: "H1",
  props: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/_variables.scss';
h1 {
  font-size: $font-size-xxxxl;
  line-height: $font-size-xxxxl;
  color: $black;
  font-weight: 700;

  @media (max-width: $mobile-hd-width) {
    font-size: $font-size-xxxl;
    line-height: $font-size-xxxl;
  }
}
.card-form-wrapper, .privacy, .terms, .faq-section {
  h1 {
    width: 100%;
    margin: 0 auto $padding-xl;
    text-align: center;
    color: $blue-navy;
    font-size: $font-size-xxl;
    font-weight: 600;
    text-align: left;
  }
}
</style>
